export default {"src":"/_next/static/media/favorite_selected.708331e8.svg","height":32,"width":37};